export default (referenceId) => {
	const timestamp = Date.now();
	const randomNum = Math.floor(Math.random() * 10000);
	return `uid_${referenceId}_${timestamp}_${randomNum}`;
};
